// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2H8mz","title":"ClientReferral_title__1uwH3","itemText":"ClientReferral_itemText__24th2"};